import _ from "lodash";

export function camelToDash(str) {
	return str
		.replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
		.replace(/([A-Z])/g, ([letter]) => `-${letter.toLowerCase()}`);
}

export function camelToUnderScore(str) {
	return str
		.replace(/(^[A-Z])/, ([first]) => first.toLowerCase())
		.replace(/([A-Z])/g, ([letter]) => `_${letter.toLowerCase()}`);
}

export function template(text, params) {
	if (!text) {
		return text;
	}

	for (var key in params) {
		const value = params[key];

		if (_.isPlainObject(value)) {
			const { value: realValue, className } = value;
			text = text.replace(
				new RegExp("\\${" + key + "}", "g"),
				`<span class="${className ?? ""}">${realValue}</span>`
			);
		} else {
			text = text.replace(new RegExp("\\${" + key + "}", "g"), value);
		}
	}

	return text;
}

export function addWords(str, words, splitBy = " ") {
	const origWordsArray = str
		.split(splitBy)
		.map((str) => str.replace(/\s/g, ""));
	const wordsArray = words.split(splitBy).map((str) => str.replace(/\s/g, ""));
	return _.union(wordsArray, origWordsArray).join(splitBy);
}

export function removeWords(str, words, splitBy = " ") {
	const strArray = str.split(splitBy).map((str) => str.replace(/\s/g, ""));
	const wordsArray = words.split(splitBy).map((str) => str.replace(/\s/g, ""));
	_.remove(strArray, (str) => {
		return wordsArray.includes(str);
	});
	return strArray.join(splitBy);
}
